import React, { useContext, useEffect } from "react";
import { AuthContext } from "../utils/authProvider";

export const SilentRenew = () => {
  const authService = useContext(AuthContext);

  useEffect(() => {
    authService.signinSilentCallback();
  }, [authService]);

  return <span>loading...</span>;
};